<template>
  <div ref="containerRef" class="animacion-elegante">
    <!-- Marco para el revelado editorial a pantalla completa -->
    <div ref="frameRef" class="foto-frame">
      <img
        ref="fotoRef"
        src="@/assets/30991_11zon.webp"
        alt="Foto destacada"
        class="foto-elegante-full"
      />
    </div>
  </div>
</template>

<script>
import { ref, onMounted, onUnmounted } from 'vue'
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export default {
  name: 'AnimacionFotoPrincipal',
  setup() {
    const containerRef = ref(null)
    const frameRef = ref(null)
    const fotoRef = ref(null)
    let ctx = null

    onMounted(() => {
      ctx = gsap.context(() => {
        const tl = gsap.timeline({
          scrollTrigger: {
            trigger: containerRef.value,
            start: 'top 85%', // Se activa al entrar al viewport del celular
            toggleActions: 'play none none none'
          }
        })

        // 1. Revelado tipo cortina vertical sin bordes
        tl.fromTo(
          frameRef.value,
          {
            y: 50,
            opacity: 0,
            clipPath: 'inset(100% 0% 0% 0%)'
          },
          {
            y: 0,
            opacity: 1,
            clipPath: 'inset(0% 0% 0% 0%)',
            duration: 1.4,
            ease: 'power4.out'
          }
        )
        // 2. Micro-zoom y desenfoque inicial
        .fromTo(
          fotoRef.value,
          {
            scale: 1.12,
            filter: 'blur(8px)'
          },
          {
            scale: 1,
            filter: 'blur(0px)',
            duration: 1.8,
            ease: 'power3.out'
          },
          '-=1.4'
        )
      }, containerRef.value)
    })

    onUnmounted(() => {
      if (ctx) ctx.revert()
    })

    return {
      containerRef,
      frameRef,
      fotoRef
    }
  }
}
</script>

<style scoped>
.animacion-elegante {
  position: relative;
  width: 100vw; /* Fuerza el ancho total del viewport */
  margin-left: calc(-50vw + 50%); /* Rompe padding de contenedores padre */
  margin-right: calc(-50vw + 50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  
  margin-top: 20px;
  margin-bottom: -20px;
  padding: 0; /* Cero márgenes ni rellenos */
  overflow: hidden;
}

.foto-frame {
  width: 100%;
  max-width: 100%;
  overflow: hidden;
  border-radius: 0; /* Esquinas completamente rectas */
  will-change: transform, clip-path, opacity;
}

.foto-elegante-full {
  width: 100%;
  height: auto;
  display: block;
  object-fit: cover;
  will-change: transform, filter;
}
</style>